import React from 'react';
import styled from '@emotion/styled';
import CardConfiguracaoUnidade from '../../components/CardConfiguracaoUnidade';
import { situacoesAgendamento } from '../sistema/sub-tabs/agendamento/constants';

export const Financeiro = ({ venda, configuracaoUnidade, onChange, disabled }) => {
  return (
    <Container>
      <CardConfiguracaoUnidade
        title="Integração gestão financeira"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'notificaValorZeroAzulControle', label: 'Notificar orçamento valor zero?', type: 'switch' },
          { value: 'notificaAzulControleAgendamentoSala', label: 'Notificar os agendamentos de sala ao financeiro completo?', type: 'switch' },
          { value: 'utilizaFinanceiroAppHealth', label: 'Utilizar o sistema nativo do App Health?', type: 'switch' },
          { value: 'utilizaContratoAzulControle', label: 'Utilizar os contratos?', type: 'switch' },
          { value: 'utilizaRepasseAutomaticoProcedimentoOrcamento', label: 'Utilizar o repasse automático ao finalizar os procedimentos odontológicos?', type: 'switch' },
          { value: 'planoBeneficio', label: 'Utiliza plano de benefício?', type: 'switch' },
          { value: 'situacoesNotificaAzulControle', label: 'Situações de agendamento para notificar o financeiro completo', type: 'multiSelect', options: situacoesAgendamento },
        ]}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
